// @flow
/* eslint-disable max-len,react/require-default-props */

import * as React from 'react';
import { SvgXml } from 'react-native-svg';
import {
    Platform,
} from 'react-native';

const styles = {
    first: {
        fill: 'none',
        stroke: '#bfcd31',
        strokeMiterlimit: 10,
    },
};

const xml = `
           <svg xmlns="http://www.w3.org/2000/svg" width="55" height="26" viewBox="0 0 21 29.59">
            <title>accountProfile</title>
            <g id="Layer_2">
                <g id="Layer_1-2">
                    <path d="M16.82,6.49a6,6,0,1,1-6-6A6,6,0,0,1,16.82,6.49Z" style={styles.first} />
                    <rect x="0.5" y="15.09" width="20" height="14" rx="5.89" style={styles.first} />
                </g>
            </g>
        </svg>
`;

const AccountProfileIcon = () => (
    Platform.OS === 'web' ? (
        <svg xmlns="http://www.w3.org/2000/svg" width="55" height="26" viewBox="0 0 21 29.59">
            <title>accountProfile</title>
            <g id="Layer_2">
                <g id="Layer_1-2">
                    <path d="M16.82,6.49a6,6,0,1,1-6-6A6,6,0,0,1,16.82,6.49Z" style={styles.first} />
                    <rect x="0.5" y="15.09" width="20" height="14" rx="5.89" style={styles.first} />
                </g>
            </g>
        </svg>
    ) : (<SvgXml xml={xml} />)
);

export default AccountProfileIcon;
